module.exports = __webpack_public_path__ + "static/media/Data_Cancelamento.99f137a6.svg";